import { useState } from "react";
import { colors, Typography } from "@mui/material";
import { Box } from "@mui/material/node_modules/@mui/system";
import { Product } from "api";
import ProductTile from "components/ProductTile/ProductTile";
import { NavBar } from "components/NavBar/NavBar";
import { ProgressIndicator } from "components/ProgressIndicator/ProgressIndicator";
import { useMobileContext } from "context/mobile/mobileContext";
import { useIntl } from "react-intl";
import { DefaultTheme } from "@byte-coach/admin-ui-components";

export type ProductsByCategory = { [category: string]: Product[] };
export type Category = {
  id: string,
  value: string,
  href: string
};

interface HomePageProps {
  isLoading: boolean;
  categories?: Category[];
  productsByCategory: ProductsByCategory;
}

export function HomePage({
  isLoading,
  categories,
  productsByCategory,
}: HomePageProps) {
  const intl = useIntl();
  const [searchValue, setSearchValue] = useState<string | undefined>('');
  const { addItem, removeItem, cart } = useMobileContext();

  return (
    <>
      <Box sx={{ marginTop: '77px' }}>
        <Typography variant="h5" component='h1' sx={{ fontWeight: 'medium' }}>
          {intl.formatMessage({ id: 'mobile.heading.title' })}
        </Typography>
        <Typography variant="caption" sx={{ color: colors.grey[600] }}>
          {intl.formatMessage({ id: 'mobile.heading.subTitle' })}
        </Typography>
      </Box>

      {categories && <NavBar links={categories} onSearch={setSearchValue} />}

      {isLoading && (
        <ProgressIndicator />
      )}

      {!isLoading && !categories?.length && (
        <Typography sx={{ marginTop: '100px', textAlign: 'center', color: DefaultTheme.palette.primary.main }}>
          {intl.formatMessage({ id: 'mobile.message.noProducts' })}
        </Typography>
      )}

      <>
        {categories && categories.map((category) => (
          <Box sx={{ marginTop: '24px' }} key={category.id}>
            <Typography variant="h6" component='h2' id={category.id}>
              {category.value}
            </Typography>
            {productsByCategory[category.id]
              .filter(({ searchField }) => {
                return searchValue?.length && searchField
                  ? searchField.includes(searchValue.toLowerCase())
                  : true;
              })
              .map((product, index) => (
                <Box sx={{
                  borderTop: index !== 0 ? `1px solid ${colors.grey[200]}` : '0px'
                }} key={product.id}>
                  <ProductTile
                    {...product}
                    {...(cart.find(({id}) => id === product.id) || {})}
                    onAdd={addItem}
                    onRemove={removeItem}
                  />
                </Box>
              ))}
          </Box>
        ))}
      </>
    </>
  )
}
